<template>
  <form class="mt-2" id="form-modal" @submit.prevent="submitForm">
    <div class="col-md-12 px-0">
      <div class="col-md-12 style-label">
        <label class="label-form" for="status">Change Status:</label>
        <select
            id="status"
            class="form-control py-0"
            v-model="selectedStatus"
            :data-id="ticketId"
        >
          <option
              v-for="status in renderStatusOptions"
              :key="status.value"
              :value="status.value"
          >
            {{ status.text }}
          </option>
        </select>
      </div>

      <div class="text-right">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="submit" class="btn btn-default ml-1">
          <font-awesome-icon
              v-if="miniLoading"
              icon="spinner"
              class="spinner-icon"
          />
          {{ action === 'edit' ? "Update" : "Save" }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      miniLoading: false,
      selectedStatus: null,
      ticketId: null,
      selectedTab: localStorage.getItem("supportTab"),
      openStatusOption: [
        {value: 0, text: 'Open'},
        {value: 1, text: 'In Progress'},
        {value: 10, text: 'Closed'},
      ],
      inprogressStatusOption: [
        {value: 1, text: 'In Progress'},
        {value: 10, text: 'Closed'},
      ],
      indevelopmentStatusOption: [
        {value: 3, text: 'In Development'},
        {value: 10, text: 'Closed'},
      ],
    };
  },

  computed: {
    renderStatusOptions() {
      console.log("status =>", this.formData.ticket_status)
      switch (this.formData.ticket_status) {
        case "0":
          return this.openStatusOption;
        case "1":
          return this.inprogressStatusOption;
        case "3":
          return this.indevelopmentStatusOption;
        default:
          return [];
      }
    },
  },

  created() {
    this.initializeTicketData();
  },

  watch: {
    formData: {
      handler: 'initializeTicketData',
      deep: true,
    },
  },

  methods: {
    initializeTicketData() {
      this.selectedStatus = this.formData.ticket_status;
      this.ticketId = this.formData.ticket_id;
    },

    submitForm() {
      this.miniLoading = true;
      const statusUpdate = {
        ticket_id: this.ticketId,
        status: this.selectedStatus,
      };

      this.$store.dispatch("support/changeTicketStatus", statusUpdate)
          .then(() => {
            this.$toast.success('Ticket status has been updated successfully');
            this.resetForm();
            this.$store.dispatch("support/getAllTickets", [1, this.selectedTab, '', false]);
          })
          .catch(() => {
            this.$toast.error('OOPS! Something went wrong');
            this.resetForm();
          });
    },

    resetForm() {
      this.miniLoading = false;
      window.$('#modal').modal('hide');
    },
  },
};
</script>

<style>
.spinner-icon {
  animation: spin 2s linear infinite;
  float: right;
  margin-left: 5px;
  margin-top: 3px;
}
</style>
